<template>
  <div
    class="mb-10"
    :data-ab-id="dataAbId"
  >
    <div class="px-5 py-3 tablet:p-3">
      <h2
        v-if="topTitle"
        class="font-bold"
        :style="{
          color: topTitleColor,
        }"
      >
        {{ topTitle }}
      </h2>
      <p
        class="flex gap-sm"
        :style="{ color: subTitleTextColor }"
      >
        {{ subTitleText }}
        <SharedLink
          v-if="link"
          :link="link"
          :style="{ color: ctaTextColor }"
        >
          <span>{{ ctaText }}</span>
        </SharedLink>
      </p>
    </div>
    <KikCarousel>
      <div
        v-for="(product, index) in products"
        :key="index"
        class="w-[65vw] shrink-0 rounded-md first:ms-auto last:me-auto hover:shadow-lg md:w-[200px] lg:w-[300px] xl:w-[400px]"
      >
        <SharedTeaserCard
          :title="product.title"
          :title-color="product.titleColor"
          :introduction="product.introduction"
          :introduction-color="product.introductionColor"
          :src="product.src"
          :src-set="product.srcSet"
          :alt="product.alt"
          :link="product.ctaLink"
        />
      </div>
    </KikCarousel>
  </div>
</template>

<script lang="ts" setup>
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

interface Props {
  topTitle?: string;
  topTitleColor?: string;
  subTitleText?: string;
  subTitleTextColor?: string;
  ctaTextColor?: string;
  ctaLink?: any[];
  slides?: any[];
  dataAbId?: string;
}

const props = withDefaults(defineProps<Props>(), {
  topTitle: '',
  topTitleColor: '',
  subTitleText: '',
  subTitleTextColor: '',
  ctaTextColor: '',
  ctaLink: () => ([]),
  slides: () => [],
});

const { ctaLink, slides } = toRefs(props);
const { $domain } = useNuxtApp();

const products = computed(() => (
  slides.value?.map(slide => ({
    ...slide,
    introduction: slide.subTitle,
    introductionColor: slide.subTitleColor,
    src: magnoliaGetters.getDefaultSrcAsset(slide.image, $domain.cmsAssetDomainPath),
    srcSet: magnoliaGetters.getSrcSetImagesAsString(slide.image, $domain.cmsAssetDomainPath, slide.aspectRatio, slide.mobileAspectRatio?.[0]?.aspectRatio),
    alt: slide.image?.metadata?.caption ?? '',
    ctaLink: slide.ctaLink?.[0] ? magnoliaGetters.getLinkAndName(slide.ctaLink[0], $domain.cmsAssetDomainPath, slide.ctaLink[0].switchable?.intLinkParam) : {},
  }))
));

const link = computed(() => (ctaLink.value?.[0] ? magnoliaGetters.getLinkAndName(ctaLink.value[0], $domain.cmsAssetDomainPath, ctaLink.value[0].switchable?.intLinkParam) : {}));
const ctaText = computed(() => (ctaLink.value?.[0] ? ctaLink.value?.[0].ctaText : ''));
</script>
